export default {
      id: "left-arrow-neo-usage",
      viewBox: "0 0 45 87",
      url: __webpack_public_path__ + "img/icons.df848786.svg#left-arrow-neo",
      toString: function () {
        return this.url;
      }
    }